import { CONFIGCONSTANTS } from './../config/app-constants';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {HttpParams} from "@angular/common/http";
import { CONFIG } from '../config/app-config';
import { map } from 'rxjs/operators';
import { Manageuser } from './../model/manageuser';
import { config } from 'process';

@Injectable({
  providedIn: 'root'
})
export class ManageuserService {

  constructor( private http: HttpClient ) { }



  getAllManageUserListURL(ManageuserData: any) {
    return this.http.post<any>(CONFIG.getAllManageUserListURL, ManageuserData)
    .pipe(map(response => {
        return response;
    }));
  }
  getActiveCityList() {
    return this.http.post<any>(CONFIG.getActiveCityListURL , {} )
    .pipe(map(data => {
        return data;
      }));
  }
  getManagerUserById(id: number) {
    return this.http.get<any>(CONFIG.getManagerUserByIdURL + id)
    .pipe(map(data => {
        return data;
      }));
  }

  updateManageUser(ManageuserData: any, id: number) {
    return this.http.post<any>(CONFIG.updateManageUserURL + id, ManageuserData)
    .pipe(map(response => {
        return response;
    }));
  }

  createManageUser(ManageuserData: Manageuser) {
    return this.http.post<any>(CONFIG.createManageUserURL, ManageuserData)
    .pipe(map(response => {
        return response;
    }));
  }

  changeManageUserPassword(ManageuserData: any) {
    return this.http.put<any>(CONFIG.changeManageUserPassURL, ManageuserData)
    .pipe(map(response => {
        return response;
    }));
  }

  changeManageUserStatus(status: string, id: number, slug: string) {
    return this.http.post<any>(CONFIG.changeManageUserStatusURL, {id: id, status: status, permission_slug: slug})
    .pipe(map(response => {
        return response;
    }));
  }

  changeClinicStatus(status: string, id: number, day: string,doctor_uuids:string) {
    return this.http.post<any>(CONFIG.changeStatusClinicURL, {status: status,uuid: id,week_of_day: day,doctor_uuid:doctor_uuids})
    .pipe(map(response => {
        return response;
    }));
  }

  changeSMSStatus(is_sms_notification: string, id: number, slug: string) {
    return this.http.post<any>(CONFIG.changeSMSStatusURL, {id: id, is_sms_notification: is_sms_notification, permission_slug: slug})
    .pipe(map(response => {
        return response;
    }));
  }

  deleteManageUser(URL, id: number) {
    return this.http.delete<any>(URL + id)
    .pipe(map(response => {
        return response;
    }));
  }

  deleteUserProfile(id: any) {
    return this.http.get<any>(CONFIG.deleteUserProfileURL + id)
    .pipe(map(response => {
        return response;
    }));
  }
  checkPassword(pass) {
    if (pass != null) {
      return (pass as string).replace(/\*/g, '[*]').replace(/\^/g, '[^]').replace(/\$/g, '[$]').replace(/\+/g, '[+]');
    }
  }
  // Trim text for space issue
  trimText(str) {
    if (str) {
      return str.trim();
    } else {
      return '';
    }
  }
  getAllSpecialization() {
    return this.http.post<any>(CONFIG.getAllSpecializationsListURL, {})
    .pipe(map(response => {
        return response;
    }));
  }

  getKycDataById(id: number) {
    return this.http.get<any>(CONFIG.getKycDetailsByIdURL + id)
    .pipe(map(data => {
        return data;
      }));
  }
  approveKYCDocument(obj: any, id: number) {
    return this.http.post<any>(CONFIG.approveKYCDocumentsURL + id, obj)
    .pipe(map(response => {
        return response;
    }));
  }

  getDoctorDetailsById(id: number) {
    return this.http.get<any>(CONFIG.getDoctorDetailsByIdURL + id)
    .pipe(map(data => {
        return data;
      }));
  }

  addEditClinic(ManageuserData: any, id: number) {
    return this.http.post<any>(CONFIG.addEditClinic + id, ManageuserData)
    .pipe(map(response => {
        return response;
    }));
  }

  deleteClinic(id: any) {
    return this.http.post<any>(CONFIG.deleteClinicURL + id, {})
    .pipe(map(response => {
        return response;
    }));
  }
  addDoctorInfo(doctorData: any) {
    return this.http.post<any>(CONFIG.addDoctorInfoURL, doctorData)
    .pipe(map(response => {
        return response;
    }));
  }
  addPharmacyInfo(pharmacyData: any) {
    return this.http.post<any>(CONFIG.addPharmacyInfoURL, pharmacyData)
    .pipe(map(response => {
        return response;
    }));
  }
  updateDoctorInfo(type, id: any, data) {
    let url = '';
    if (type === 'PERSONAL') {
      url = CONFIG.updatePersonalInfo;
    }
    if (type === 'PROFESSIONAL') {
      url = CONFIG.updateProfessionalInfo;
    }
    return this.http.post<any>(url + id, data)
    .pipe(map(response => {
        return response;
    }));
  }

  getAllActiveSpecialities() {
    return this.http.get<any>(CONFIG.getActiveSpecialitiesListURL)
    .pipe(map(response => {
        return response;
    }));
  }

  getAllActiveSymptoms() {
    return this.http.get<any>(CONFIG.getActiveSymptomsListURL)
    .pipe(map(response => {
        return response;
    }));
  }

  /**Pharmacy Module */
  getPharmacyDetailsById(id: number) {
    return this.http.post<any>(CONFIG.getPharmacyDetailsByIdURL + id, {})
    .pipe(map(data => {
        return data;
      }));
  }

  updatePharmacyTimings(ManageuserData: any, id: number) {
    return this.http.post<any>(CONFIG.updatePharmcyTimingsURL + id, ManageuserData)
    .pipe(map(response => {
        return response;
    }));
  }
  
  getIndividualPharmacyList(){
    return this.http.get<any>(CONFIG.getIndividualPharmacyList)
    .pipe(map(response => {
        return response;
    }));
  }

  updatePharmacyConfig(PharmacyList:any){
    return this.http.post<any>(CONFIG.updateIndividualPharmacyList,PharmacyList)
    .pipe(map(response => {
        return response;
    }));
  }

  updatePharmacyInfo(type, id: any, data) {
    let url = '';
    if (type === 'PERSONAL') {
      url = CONFIG.updatePharmcyPersonalDetailsURL;
    }
    if (type === 'PROFESSIONAL') {
      url = CONFIG.updatePharmcyProfessionalDetailsURL;
    }
    return this.http.post<any>(url + id, data)
    .pipe(map(response => {
        return response;
    }));
  }

  getDownloadDocumentURL(url: string) {
    const awsEnabled = CONFIGCONSTANTS['isFileUploadedToAWS'] ;
    let reqUrl = CONFIG.documentDownloadAPIURL;
    reqUrl += '?file=' + url;
    if (awsEnabled) {
      reqUrl += '&aws=1';

    }
    return reqUrl;
  }

  /**Patient Module */
  getPatientUserById(id: number) {
    return this.http.get<any>(CONFIG.getPatientDetailsByIdURL + id)
    .pipe(map(data => {
        return data;
    }));
  }

  addPatientUser(data: any) {
    return this.http.post<any>(CONFIG.createPatientURL , data)
    .pipe(map(response => {
        return response;
    }));
  }

  updatePatientPersonalInfo(data: any, uuid: string) {
    return this.http.post<any>(CONFIG.updatePatientByIdURL + uuid, data)
    .pipe(map(response => {
        return response;
    }));
  }

  updatePatientLifeStyleInfo(data: any, uuid: string) {
    return this.http.post<any>(CONFIG.updatePatientLifeStyleInfoByIdURL + uuid, data)
    .pipe(map(response => {
        return response;
    }));
  }
  updatePatientVitalsInfo(data: any, id: number) {
    return this.http.post<any>(CONFIG.updatePatientVitalsInfoByIdURL + id, data)
    .pipe(map(response => {
        return response;
    }));
  }
  patientMedicalHistoryAdd(data: any, id: number) {
    return this.http.post<any>(CONFIG.addPatientMedicalHistoryURL + id, data)
    .pipe(map(response => {
        return response;
    }));
  }

  getPatientMedicalHistoryList(data: any, id: number) {
    return this.http.post<any>(CONFIG.getPatientMedicalHistoryListURL + id, data)
    .pipe(map(response => {
        return response;
    }));
  }

  deletePatientMdeicalHistory(uuid: string) {
    return this.http.delete<any>(CONFIG.deletePatientMedicalHistory + uuid, {})
    .pipe(map(response => {
        return response;
    }));
  }
  getPatientMedicalHistoryDetails(uuid: string) {
    return this.http.get<any>(CONFIG.getPatientMedicalHistoryDetailsByURL + uuid)
    .pipe(map(response => {
        return response;
    }));
  }

  deleteMedicalHistoryDocuemt(uuid: any) {
    return this.http.delete<any>(CONFIG.deletePatientMedicalHistoryDocumentURL + uuid)
    .pipe(map(response => {
        return response;
    }));
  }
  getConnectionList(data: any, id: number) {
    return this.http.post<any>(CONFIG.getConnectionListURL + id, data)
    .pipe(map(response => {
        return response;
    }));
  }
  getInventoryList(data: any, id: number) {
    return this.http.post<any>(CONFIG.getInventoryListURL + id, data)
    .pipe(map(response => {
        return response;
    }));
  }
  getDiscountList(data: any, id: number) {
    return this.http.post<any>(CONFIG.getDiscountListURL + id, data)
    .pipe(map(response => {
        return response;
    }));
  }
  getExportListDoc(data: any) {
    return this.http.post<any>(CONFIG.exportUsersURLDOC, data)
    .pipe(map(response => {
        return response;
    }));
  }
  getExportListPats(data: any) {
    return this.http.post<any>(CONFIG.exportUsersURLPATS, data)
    .pipe(map(response => {
        return response;
    }));
  }
  getExportListPhar(data: any) {
    return this.http.post<any>(CONFIG.exportUsersURLPHAR, data)
    .pipe(map(response => {
        return response;
    }));
  }
  importListPatient(data: any) {
    return this.http.post<any>(CONFIG.importListPatientURL, data)
    .pipe(map(response => {
        return response;
    }));
  }

  deleteConsultant(uuid: number) {
     return this.http.delete<any>( CONFIG.deleteConsultantUrl + uuid ).pipe(
       map(response => {
        return response;

     }));

  }

  deleteMedicalHistory(uuid: number) {
     return this.http.delete<any>( CONFIG.deleteHistory + uuid ).pipe(
       map(response => {
        return response;

     }));
  }

  deleteDocument(uuid: number) {
    return this.http.delete <any> ( CONFIG.deleteDocument + uuid ).pipe(
      map ( response => {
       return response;
    }));
  }

  deletePharmacyDocument(uuid: number) {
    return this.http.delete <any> ( CONFIG.deletePharmDocument + uuid ).pipe(
      map ( response => {
       return response;
    }));
  }

  deleteOrderDocument(uuid: number) {
    return this.http.delete <any> ( CONFIG.deleteOrderDocument + uuid ).pipe(
      map ( response => {
       return response;
    }));
  }

  getPatientFamilyListing( Familydata: any) {
    return this.http.post <any> ( CONFIG.getPatientFamilyList  , Familydata)
    .pipe( map ( response => {
        return response;
    }));
  }

  deleteFamily( uuid: number) {
    return this.http.delete<any>( CONFIG.deleteFamily + uuid ).pipe(
      map ( response => {
       return response;
    }));

  }

  changeFamilyStatus(status: number, id: number , parent_user_id: number) {

    return this.http.put<any>( CONFIG.changeFamilyStatusURL , { uuid: id, is_activatd_account: status, parent_user_id: parent_user_id })
      .pipe(
        map((response) => {
          return response;
        }));
  }

  getFamilyMemberById(uuid: any) {

    return this.http.get<any>(CONFIG.getFamilyIdByURL + uuid).pipe(
      map((respose) => {
        return respose;
      })
    );


  }

  getFamilyRelation() {
    return this.http.get<any>(CONFIG.getFamilyRelation).pipe(
      map((respose) => {
        return respose;
      })
    );


  }

  createFamily(Familydata: any) {
    return this.http.post<any>(CONFIG.createFamilyURL, Familydata).pipe(
      map((response) => {
        return response;
      })
    );
  }


  updateFamily(ManageFamilyData: any ) {

    return this.http.post<any>(CONFIG.updateFamilyURL , ManageFamilyData ).pipe(
      map((response) => {
        return response;
      })
    );
  }

  createPharmacyGroup(cPharmacyGroup: any) {
    return this.http.post<any>(CONFIG.createPharmacyGroupByURL, cPharmacyGroup).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getAllPharmacyGroupList() {
    return this.http.post<any>(CONFIG.getAllPharmacyGroupListURL,{})
    .pipe(map(response => {
        return response;
    }));
  }

  getPatientAssignGroup(id: number, data){
    return this.http.post<any>(CONFIG.patientGroup , data)
    .pipe(map(response => {
      return response;
    }));
  }

 redeemDoctorPoints(user_id: number, redeem_points: number) {
  return this.http.post<any>(
    CONFIG.redeemPointsURL,
    {
      user_id: user_id,
      redeem_points: redeem_points
    }
  )
  .pipe(
    map(response => {
      return response;
    })
  );
}



}